import React, { CSSProperties } from "react";
import {
	Table,
	TableBody,
	TableRow,
	TableCell,
	TableContainer,
	Paper,
} from "@mui/material";
import { Progress } from "antd";

export interface ProgressListItem {
	label: string;
	value: number;
	percentage: number;
}

interface ProgressListTableProps {
	title: string;
	subTitle?: string;
	items: ProgressListItem[];
	style?: CSSProperties | undefined;
	progressBarColor?: string;
}

const ProgressListTable = ({
	title,
	subTitle,
	items,
	style,
	progressBarColor,
}: ProgressListTableProps) => {
	return (
		<div className="progressListTable" style={style}>
			<div
				className="flex flex-col gap-2 pb-2 "
				style={{ paddingLeft: "14px", paddingTop: "12px" }}
			>
				<h1 className="StatisticTitle">{title}</h1>
				<p className="progressListSubTitle">{subTitle}</p>
			</div>
			<TableContainer className="scrollableStyle">
				<Table>
					<TableBody>
						{items?.map((item, index) => (
							<TableRow key={index}>
								<TableCell
									colSpan={2}
									style={{
										borderBottom: "none",
										paddingBottom: "1px",
										padding: "none",
									}}
								>
									<div className="flex flex-col w-full">
										<div className="flex justify-between items-center w-full">
											<span className="!text-[#828282]">
												{item.label}
											</span>
											<div className="flex items-center gap-2">
												<strong>{item.value}</strong>
												<span>
													({item.percentage}%)
												</span>
											</div>
										</div>

										<div
											// className="mt-1"
											style={{ width: "100%" }}
										>
											<Progress
												percent={item.percentage}
												status="active"
												strokeColor={progressBarColor}
												showInfo={false}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default ProgressListTable;
